import { Loader2 } from "lucide-react";

export function PageSkeleton() {
  return (
    <div className="flex flex-col items-center justify-center py-10  text-center text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-base font-medium">
        Cargando módulo
      </p>
      <p className="text-sm">
        Aguarde un momento mientras se prepara el contenido.
      </p>
    </div>
  );
}